export default "__VITE_ASSET__31574b7a__"